import React, { ChangeEvent } from 'react';
import { Switch } from '@hqo/react-components-library';
import { TextContainer, SwitchContainer, Title, Container, Subtitle } from './styles';
import { useIntl } from 'react-intl';
import { usePresetWindowToggle } from './hooks/use-preset-window-toggle.hook';

interface PresetWindowToggleProps {
  onChangeToggle?: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const PresetWindowToggle = ({ onChangeToggle }: PresetWindowToggleProps): JSX.Element => {
  const intl = useIntl();
  const { checked, onChangeHandler, isDisabled } = usePresetWindowToggle(onChangeToggle);

  return (
    <Container>
      <SwitchContainer>
        <Switch disabled={isDisabled} onChange={onChangeHandler} checked={checked} />
      </SwitchContainer>
      <TextContainer>
        <Title disabled={isDisabled}>{intl.formatMessage({ id: 'all_day' })}</Title>
        <Subtitle disabled={isDisabled}>{intl.formatMessage({ id: 'hours_may_vary' })}</Subtitle>
      </TextContainer>
    </Container>
  );
};
